var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4688,
    cy: 20.01,
    r: 20,
    fill: "#62C572"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4688 30.51C26.2677 30.51 30.9688 25.809 30.9688 20.01C30.9688 14.211 26.2677 9.51001 20.4688 9.51001C14.6698 9.51001 9.96875 14.211 9.96875 20.01C9.96875 25.809 14.6698 30.51 20.4688 30.51Z",
    fill: "#62C572"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7656 15.31L18.9656 22.11L16.1656 19.31L14.7656 20.71L18.9656 24.91L27.1656 16.71L25.7656 15.31Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInGreen);
export default __webpack_public_path__ + "static/media/IN_green.b6c1643fa1312fe74b45177f9a2ae3fd.svg";
export { ForwardRef as ReactComponent };